import { Tabs } from '@statsbomb/kitbag-components';
import { useAtom, useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { metricsAtom } from '@/atoms/metric';
import { radarTemplateActiveTabAtom } from '@/atoms/radar';
import { RadarTemplateModalTab, Tab } from '@/types/tabs';

const translations = 'createRadarTemplateModal.mobile.tabs';

export const MobileMetricSelectTabs = () => {
  const { t } = useTranslation('modal');
  const [activeTab, setActiveTab] = useAtom(radarTemplateActiveTabAtom);
  const selectedMetrics = useAtomValue(metricsAtom);

  const onTabChange = (_: React.MouseEvent<HTMLElement>, { value }: Tab<RadarTemplateModalTab>) => setActiveTab(value);

  const tabs = [
    { value: RadarTemplateModalTab.AVAILABLE_METRICS, label: t(`${translations}.availableMetrics`) },
    {
      value: RadarTemplateModalTab.SELECTED_METRICS,
      label: t(`${translations}.selectedMetrics`, { count: selectedMetrics.length }),
    },
  ];

  return (
    <div className="md:hidden">
      <Tabs tabs={tabs} activeTab={activeTab} onTabChange={onTabChange} />
    </div>
  );
};
